<div class="flex justify-between">
  @if (isPolicyPage) {
    <h1 class="app">{{summary().businessInfo?.businessName}} - {{this.summary().policyNumber }}</h1>
    @if (!authStore.isLossRunProcessor()) {
      <lib-button [cssType]="'btn-dropdown'"  [menuItems]="policyMenuItems()" [text]="'Endorsement Request'" [icon]="'downcaret'" (mainClick)="export()"></lib-button>
    }
  } @else {
    <h1 class="app">{{summary().businessInfo?.businessName}} - {{summary().submissionNumber}}</h1>
    <lib-button [cssType]="'btn-dropdown'" [menuItems]="submissionMenuItems()" [text]="mainSplitButtonText()" [icon]="'downcaret'" (mainClick)="mainSplitButtonAction()" [disabled]="isMainButtonDisabled()"></lib-button>
  }
</div>

<div class="mt-2">
  <lib-button  [cssType]="'btn-link'"  [text]="backText()" [icon]="'circleleft'"  [buttonType]="'button'"  (click)="goBack()"></lib-button>
</div>


<lib-toolbar
  [tiles]="toolbarTiles"
  [layout]="'column'"
  (click)="toolbarClick($event)">
</lib-toolbar>

<mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)">
  @if (authStore.isLossRunProcessor()) {
    <mat-tab label="Loss Runs">
      <lib-loss-runs (changeTabEvent)="changeTab($event)"></lib-loss-runs>
    </mat-tab>
    <mat-tab label="Documents">
      <lib-documents (changeTabEvent)="changeTab($event)"></lib-documents>
    </mat-tab>
  } @else {
    <mat-tab label="Summary">
      <lib-summary (changeTabEvent)="changeTab($event)"></lib-summary>
    </mat-tab>
    <mat-tab label="Pricing">
      <lib-pricing (changeTabEvent)="changeTab($event)"></lib-pricing>
    </mat-tab>
    @if (isPolicyPage) {
      <mat-tab label="Policy Documents">
        <lib-policy-documents (changeTabEvent)="changeTab($event)"></lib-policy-documents>
      </mat-tab>
      <mat-tab label="Endorsements">
        <lib-endorsements (changeTabEvent)="changeTab($event)"></lib-endorsements>
      </mat-tab>
      <mat-tab label="Loss Runs">
        <lib-loss-runs (changeTabEvent)="changeTab($event)"></lib-loss-runs>
      </mat-tab>
    }
    <mat-tab label="Documents">
      <lib-documents (changeTabEvent)="changeTab($event)"></lib-documents>
    </mat-tab>
  }
</mat-tab-group>
<router-outlet></router-outlet>
